<template>
  <div style="display: inline; padding: 0px; margin: 0px;">
    <template v-if="shouldOpenInNewTab || alwaysA">
      <a
        :href="href"
        target="_blank"
        class="dropdown-item"
      >
        <!-- :class="{'active': isActive}" -->
        <slot></slot>
      </a>
    </template>
    <template v-else>
      <router-link
        :to="href"
        class="nav-link"
      >
        <!-- :class="{'active': isActive}" -->
        <slot></slot>
      </router-link>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    href: {
      type: String,
      default: null
    },
    alwaysA: Boolean,
  },
  computed: {
    ...mapGetters([
      'dashboardInstanceBaseURL',
      'activeDashboardLink',
      'activeEnvironment',
      'activeSignInConfig',
      'canViewDemo',
      'demo',
      'authToken',
      'hasAuthToken',
      'canSelectGame',
      'canRestartGame',
      'canManageDashboards',
      'canManageGames',
      'canManageGameSets',
      'canManageGameInvites',
      'canManageEnvironments',
      'canViewDashboards',
      'canManageUsers',
      'canManageClasses',
      'canGenerateReports',
      'canManageAllGroups',
      'canUseSaveStates',
      'dashboardsEnabled',
      'isOwnerOrAdmin',
      'me',
      'showAdmin',
      'zoom',
      'isStudent',
      'isProfessor',
      'isManager',
      'isOwnerAdminOrProfessor',
      'activeToggleSettings',
      'isLti',
      'hasAnonymousIdParam',
      'anonymousIdParam',
      'classTypeNamePlural',
      'cachedActiveGameSetGames'
    ]),
    isDemoRoute() {
      return this.$route.path.startsWith('/demo');
    },
    isGameRoute() {
      return this.$route.path.startsWith('/groups');
    },
    isDemoOrGameRoute() {
      return this.isDemoRoute || this.isGameRoute;
    },
    isHubRoute() {
      return this.$route.path.startsWith('/hub');
    },
    shouldOpenInNewTab() {
      return this.isDemoOrGameRoute || this.isHubRoute || this.isLti;
    },
  }
  // watch: {
  //   $route(to, from) {
  //     this.computeStyle(to, from);
  //   },
  //   async headerHasChanged() {
  //     await Vue.nextTick();
  //     this.exportHeaderHeight();
  //   }
  // }
};
</script>

<style lang="scss" scoped>
  .nav-link {
    color: var(--navBarTextColor) !important;
    margin: 0 2px;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
    padding: 4px 24px !important;
  }
  .nav-link:hover {
    // background-color: rgba(0, 0, 7, 0.2);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-item {
    color: var(--navBarTextColor) !important;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    text-transform: lowercase;
    font-weight: 100;
    padding: 4px 24px;
  }
  .dropdown-item:hover {
    // background-color: rgba(0, 0, 7, 0.4);
    background-color: var(--navBarHoverColor);
  }

  .dropdown-divider {
    border-color: var(--primaryColor);
  }

  .username {
    text-transform: unset !important;
  }

.navbar-bg {
  // background-color: rgba(0, 0, 7, 0.76);
  background-color: var(--navBarDropdownColor);
}

.navbar-logo {
  height: 100%;
  position: relative;
  flex-shrink: 1;
  flex-grow: 10;
  flex-basis: 0;
}
.navbar-logo.centered-title {
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  flex-basis: 33% !important;
  width: 33% !important;
}
.logo-link {
  outline-color: white;
  height: 100%;
  padding: 0 6px 2px;
}
.logo {
  height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.navbar-brandText {
  flex-shrink: 1;
  flex-grow: 25;
  flex-basis: 0;
  padding: 0 5px;
  color: var(--navBarTextColor);
  outline-color: white;
  width: auto;
  margin: auto 0;
  text-align: center;
  white-space: nowrap;
  font-size: calc(max(14.419px,min(16pt, 1.45vw)));
  font-weight: bold;
  font-family: unset;
  // font-weight: normal;
  // font-family: "Book Antiqua", Palatino, serif;
  // justify-self: center;
  // align-self: center;
}
.navbar-brandText.centered-title {
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  flex-basis: 33% !important;
  width: 33% !important;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.navbar-actionItems {
  // width: 50%;
  // height: auto;
  // display: flex;
  // flex-direction: row;
  // justify-content: flex-end;
  background-color: var(--navBarColor);
  z-index: 1000;
  border-radius: 8px;
  white-space: nowrap;
  // flex-shrink: 1;
  // flex-basis: 0;
}
.navbar-actionItems.centered-title:not(.collapse):not(.collapsing) {
  flex-grow: 0 !important;
  flex-shrink: 0 !important;
  flex-basis: 33% !important;
  width: 33% !important;
  background-color: transparent !important;
}

.navbar-brand:focus, .nav-item a:focus {
  outline-color: white;
}

.nav-item {
  line-height: 120%;
}

.title {
  color: var(--primaryColor);
  background-color: white;
  font-size: 72px;
  font-weight: bold;
  border-radius: 0;
  margin: 0;
  padding: 40px;
}
.demo-links {
  display: flex;
  flex-flow: row;
  justify-content: flex-end;
}
.demo-link {
  color: black;
  padding: 2px 5px;
}
.demo-link:hover, .demo-link:focus {
  text-decoration: none;
  color: var(--primaryColor);
}
.demo-link:focus {
  outline: none;
}

.dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(180deg);
}
.dropdown-toggle:after {
  transition: 0.4s;
}

.navbar-item-divider {
  //width: 1.3px;
  //background-color: var(--primaryColor);
  // Doing it with border rather than width because borders tend to render thin lines more cleanly
  // across different browsers
  height: 72%;
  width: 0px;
  margin: 5px 4px;
  border-right: 1px solid var(--primaryColor);
}

.survey-exit-btn {
  // From nav-link
  margin: 2px 2px 0px 0px;
  padding-left: 10px;
  padding-right: 10px;
  border: none !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;

  color: white !important;
  font-weight: 800 !important;
  font-size: 16px;

  // background-color: red;
  background-image: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/display/NavbarLink.vue